import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#arrow-up_svg__a)">
      <path d="M21 11a1 1 0 0 1-.71-.29L12 2.41l-8.29 8.3a1.004 1.004 0 1 1-1.42-1.42l9-9a1 1 0 0 1 1.42 0l9 9a1 1 0 0 1 0 1.42A1 1 0 0 1 21 11" />
      <path d="M12 24a1 1 0 0 1-1-1V1a1 1 0 0 1 2 0v22a1 1 0 0 1-1 1" />
    </g>
    <defs>
      <clipPath id="arrow-up_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgArrowUp;
